import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.PartidaAclaracionFactura;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de edición para un factura de PartidaAclaracion
*/
export class PartidaAclaracionGuiaEdit extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            IdFactura: validation.required,
        };
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Factura = getField(selectores.Factura);
        const Text = getField(kea.Text);
        const CondicionPago = getField(selectores.CondicionPagoSelector);
        const DescripcionConcepto = getField(selectores.DescripcionConceptoSelector);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="Agregar factura"
            >

            <Factura field="IdFactura" label="Factura"/>,
            <Text field="Observaciones" label="Observaciones" />,
            <CondicionPago field="Condicion" label="Condición de pago" />,
            <DescripcionConcepto field="DescripcionConcepto" label="Descripción de concepto" />
            </kea.Modal>
        )
    }
}   



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/partidasaclaracion/edit/facturas/edit.tsx